import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { AvailableArea } from 'src/app/models/available-areas/available-area';

@Injectable({ providedIn: 'root' })
export class AvailableAreasApi {
  constructor(private afs: AngularFirestore) {}

  getAll(): Observable<AvailableArea[]> {
    const availableAreas = this.afs.collection<AvailableArea>(
      'service_environments/availability_information/areas',
    );

    return availableAreas.valueChanges();
  }
}
